/* eslint-disable react/display-name */
import React from 'react';
import BoxHistoryTab from './BoxHistoryTab';
import HeroHistoryTab from './HeroHistoryTab';
import BalanceHistoryTab from './BalanceHistoryTab';
import RentalHistoryTab from './RentalHistoryTab';
import TransactionHistoryTab from './TransactionHistoryTab';
import { CategoryKey } from '@profile/src/utils/navigate';
import CosmeticHistoryTab from './CosmeticHistoryTab';
import VestingSafeHistoryTab from './VestingSafeHistoryTab';
export const categories = [{
  key: CategoryKey.BoxHistory,
  name: 'Box History',
  renderCategory: () => /*#__PURE__*/React.createElement(BoxHistoryTab, null)
}, {
  key: CategoryKey.HeroHistory,
  name: 'Hero History',
  renderCategory: () => /*#__PURE__*/React.createElement(HeroHistoryTab, null)
}, {
  key: CategoryKey.CosmeticHistory,
  name: 'Cosmetic History',
  renderCategory: () => /*#__PURE__*/React.createElement(CosmeticHistoryTab, null)
}, {
  key: CategoryKey.TransactionHistory,
  name: 'Transaction History',
  renderCategory: () => /*#__PURE__*/React.createElement(TransactionHistoryTab, null)
}, {
  key: CategoryKey.BalanceHistory,
  name: 'Balance History',
  renderCategory: () => /*#__PURE__*/React.createElement(BalanceHistoryTab, null)
}, {
  key: CategoryKey.RentalHistory,
  name: 'Renting History',
  renderCategory: () => /*#__PURE__*/React.createElement(RentalHistoryTab, null)
}, {
  key: CategoryKey.VestingSafeHistory,
  name: 'Vesting Safe History',
  renderCategory: () => /*#__PURE__*/React.createElement(VestingSafeHistoryTab, null)
}];